import { WindFarmRepository, WindTurbineTypeRepository, WindTurbineBladeTypeRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    wind_farms: [],
    turbineList: [],
    bladeList: [],
    wind_turbines: []
  },
  mutations: {
    SET_VAR (state, params) {
      state[params.key] = params.value
    },
    getFarms (state, farms) {
      state.wind_farms = []
      state.wind_farms = farms
    },
    getTurbineList (state, list) {
      state.turbineList = []
      state.turbineList = list
    },
    getBladeList (state, list) {
      state.bladeList = []
      state.bladeList = list
    }
  },
  actions: {
    // Get
    getFarms ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WindFarmRepository.getAll(obj)
          .then(response => {
            const farms = response.data.data.reverse()
            commit('getFarms', farms)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getTurbineList ({ commit }) {
      return new Promise((resolve, reject) => {
        WindTurbineTypeRepository.getAll()
          .then(response => {
            const list = response.data.data
            commit('getTurbineList', list)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getBladeList ({ commit }) {
      return new Promise((resolve, reject) => {
        WindTurbineBladeTypeRepository.getAll()
          .then(response => {
            const list = response.data.data
            commit('getBladeList', list)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    windTurbines ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WindFarmRepository.windTurbines(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'wind_turbines', value: data })
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    // Actions    
    createFarm (context, farm) {
      return new Promise((resolve, reject) => {
        WindFarmRepository.create(farm)
          .then(() => {
            resolve();
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editFarm (context, farm) {
      return new Promise((resolve, reject) => {
        WindFarmRepository.update(farm)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    deleteFarm (context, id) {
      return new Promise((resolve, reject) => {
        WindFarmRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
  }
}
